import { useLoader } from "./LoaderContext";

const GlobalLoader = () => {
  const { loading } = useLoader();

  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-white/70 backdrop-blur-sm">
      <div className="flex flex-col items-center space-y-4">
        {/* Elegant Pulse Loader */}
        <div className="flex space-x-2">
          <span className="w-4 h-4 bg-primary rounded-full animate-bounce [animation-delay:-0.3s]" />
          <span className="w-4 h-4 bg-primary rounded-full animate-bounce [animation-delay:-0.15s]" />
          <span className="w-4 h-4 bg-primary rounded-full animate-bounce" />
        </div>
        <p className="bg-primaryLight font-medium text-sm tracking-wide animate-pulse">
          Please wait, loading...
        </p>
      </div>
    </div>
  );
};

export default GlobalLoader;
